export function omit(obj, keys_to_omit) {
    const entries = Object.entries(obj);
    const filtered_entries = entries.filter(([key]) => !keys_to_omit.includes(key));
    return Object.fromEntries(filtered_entries);
}
